// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_array from "../../../../../rescript/lib/es6/caml_array.js";
import * as Caml_option from "../../../../../rescript/lib/es6/caml_option.js";
import * as Exception$Catalyst from "./types/Exception.bs.js";

function isCors(errorString) {
  var match_ = errorString.match(/(TypeError: Origin https:\/\/)(([a-z]+)||(([a-z]+)\-([a-z]+)\-\d))(\.)(porter)(\.)(in)( is not allowed by Access-Control-Allow-Origin)/);
  return match_ !== null;
}

function mapErrorsToExn(error) {
  console.log("------undefined-error-handler------");
  console.log("------js.promise.error |> toString------");
  console.log(error.toString());
  var match = error.toString();
  switch (match) {
    case "TypeError: A server with the specified hostname could not be found." :
    case "TypeError: Failed to fetch" :
    case "TypeError: Network request failed" :
    case "TypeError: NetworkError when attempting to fetch resource." :
    case "TypeError: The internet connection appears to be offline." :
    case "TypeError: The network connection was lost." :
        return {
                RE_EXN_ID: Exception$Catalyst.FailedToFetch
              };
    case "AbortError: The operation was aborted." :
    case "TypeError: The operation couldn\xe2\x80\x99t be completed. Software caused connection abort" :
        return {
                RE_EXN_ID: Exception$Catalyst.OperationAborted
              };
    case "TypeError: cancelled" :
        return {
                RE_EXN_ID: Exception$Catalyst.RequestCancelled
              };
    default:
      if (isCors(error.toString())) {
        return {
                RE_EXN_ID: Exception$Catalyst.Cors,
                _1: error.toString()
              };
      } else {
        return {
                RE_EXN_ID: Exception$Catalyst.UnhandledError,
                _1: error
              };
      }
  }
}

var UndefinedErrorHandler = {
  isCors: isCors,
  mapErrorsToExn: mapErrorsToExn
};

function getExnString(exn) {
  var result = exn.match(/(\.)(.*?)(?=\/)/);
  if (result !== null) {
    return Caml_array.get(result === null ? undefined : Caml_option.some(result), 2);
  } else {
    return "not_found";
  }
}

function mapErrorStrToExn(error, exn) {
  var match = getExnString(exn);
  if (match === "RequestTimedout") {
    return {
            RE_EXN_ID: Exception$Catalyst.RequestTimedout
          };
  } else {
    return {
            RE_EXN_ID: Exception$Catalyst.UnhandledError,
            _1: error
          };
  }
}

function mapErrorToExn(error) {
  console.log("------Js.promise.error------");
  console.log(error);
  console.log("-----exception-payload------");
  console.log(error);
  console.log("-----Js.typeof-----");
  console.log(typeof error.RE_EXN_ID);
  var match = typeof error.RE_EXN_ID;
  if (match === "undefined") {
    return mapErrorsToExn(error);
  } else {
    return mapErrorStrToExn(error, error.RE_EXN_ID);
  }
}

var ExnHandler = {
  getExnString: getExnString,
  mapErrorStrToExn: mapErrorStrToExn,
  mapErrorToExn: mapErrorToExn
};

export {
  UndefinedErrorHandler ,
  ExnHandler ,
  
}
/* No side effect */
